/** Promo Swiper 4 Column [Start] **/
if($('.module-4boxes').length || $('.module-2boxes').length){
  hp.swipers = hp.swipers || {};
  var module_4boxes = 
  {
    initialized: false
  };
  var module_2boxes = 
  {
    initialized: false
  };
  var init = function(){
    var looping = window.screen.width<768;
    var	swiperPromoProps = {
      pagination: {
        el: '.pagination-4box',
        type: 'bullets',
        clickable: true,
      },
      slidesPerView: 4,
      spaceBetween: 0,
      loop: looping,
      loopAdditionalSlides: 1,
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 0
        },
        767: {
          slidesPerView: 1.1,
          spaceBetween: 0
        },
        640: {
          slidesPerView: 1.1,
          spaceBetween: 0
        },
        320: {
          slidesPerView: 1.15,
          spaceBetween: 0
        }
      }
    }

    var swiperPromoMethods = {
      onlyMobileSwipe: true,
      a11ySwiper: true,
      resizeHandler: true,
      customMethods: [{
        fnName: "nextSlide",
        method: function (sw) {
          var element = $(sw.$el.find(".promo-box-right-arrow"));
          element.before().on("click", function (e) {
            e.stopPropagation();
            sw.slideNext();
          })
        }
      }, {
        fnName: "clickOnPromoHead",
        method: function (sw) {
            sw.$el.find(".swiper-promo-pannel").on("click", function (e) {
              $(this).find(".homepage-anchor")[0].click();
            })
        }
      }],
      swiperEvents: [{
        eventName: "slideChangeTransitionStart",
        eventMethod: function (sw) {
          if ($(sw.$el).find(".swiper-slide-active .background-black").length > 0) {
            $($(sw.$el).find(".swiper-pagination-bullet").css("background", "#424242"));
            $($(sw.$el).find(".swiper-pagination-bullet-active").css("background", "#cccccc"));
          } else {
            $($(sw.$el).find(".swiper-pagination-bullet").css("background", ""));
          }
        }
      }, {
        eventName: "transitionStart",
        eventMethod: function () {
          $('#tooltip').remove();
        }
      }]
    }

    if($('.module-4boxes').length){
      module_4boxes.instances = hp.swiperInstance('.module-4boxes', swiperPromoProps, swiperPromoMethods);  
      module_4boxes.initialized = true;
      
      $('.module-4boxes').each(function(){
      	$(this).find('.swiper-slide').each(function(i,x){
      		if(!/2|3|4|5/.test(i)){
						x.setAttribute('aria-hidden','true')
					}
      	})
      })
    }
    /** Promo Swiper 4 Column [END] **/

      /** Promo Swiper 2 Column [START] **/

    if($('.module-2boxes').length){
      swiperPromoProps.pagination = { //Override the props for 2 col promo
        el: '.pagination-2box',
        type: 'bullets',
        clickable: true,
      }
      swiperPromoProps.slidesPerView = 2 //Override the props for 2 col promo
      swiperPromoProps.breakpoints[1024].slidesPerView = 2 //Override the props for 2 col promo

      module_2boxes.instances = hp.swiperInstance('.module-2boxes', swiperPromoProps, swiperPromoMethods);
      module_2boxes.initialized = true;
    }
  }//END init
  module_4boxes.init = init;
  module_2boxes.init = init;

  hp.swipers.module_4boxes = module_4boxes;
  hp.swipers.module_2boxes = module_2boxes;

}


/** Promo Swiper 2 Column [END] **/